import "./footer-section-styles.scss";

const FooterSection = () => {
	return (
		<section className="footer-section">
			<div className="footer-section-content-wrapper">
				<div className="footer-section-content">
					<p className="left-footer-msg footer-msg">
						Build with ❤ by{" "}
						<a
							href="https://linkedin.com/in/moazamdev"
							target="_blank"
							className="humanTextFile"
						>
							Moazam Ali
						</a>
					</p>
					<p className="right-footer-msg footer-msg">
						Code + Design + Dedication © 2023 Moazam.Dev
					</p>
				</div>
			</div>
		</section>
	);
};

export default FooterSection;
